<template>

    <div class="">

        <v-select
            v-model="selectedAgency"
            :options="agencies"
            :clearable="!isDisabled"
            @search="fetchOptions"
            :disabled="isDisabled"
            label="name"
            placeholder="Select an Agency"
        ></v-select>

        <input type="hidden" name="agency_id" :value="selectedAgency ? selectedAgency.id : ''">

        <div v-if="errors.length > 0" >
            <div class="alert alert-danger mt-2" role="alert" v-for="(error, index) in errors" :key="index">
                {{ error }}
            </div>
        </div>

    </div>

</template>

<script>

import VSelect from 'vue-select';
import debounce from "lodash/debounce";
import axios from "axios";

export default {

    props: {
        agency: {
            type: Object,
            default: () => {},
            required: false
        },
        old: {
            type: String,
            required: false
        },
        errors: {
            type: Array,
            required: false
        },
        disableWhenPassedContact: {
            type: Boolean,
            default: false,
            required: false
        },
    },

    components: {
        VSelect
    },

    data() {
        return {
            selectedAgency: null,
            agencies: [],
            isDisabled: false
        }
    },

    mounted() {

        this.fetchAgencies();

        if ( this.agencies.length === 1 ) {
            this.selectedAgency = this.agencies[0];
        }

        if (this.agency) {
            this.selectedAgency = this.agencies.find(agencies => agencies.id === this.agency.id);
        }

        if (this.old) {
            this.selectedAgency = this.agencies.find(agencies => agencies.id === this.old);
        }

        if (this.disableWhenPassedContact) {
            this.isDisabled = true;
        }

    },

    methods: {

        fetchOptions(search, loading) {
            if (search.length > 2) {
                this.debounceFetchOptions(search, loading);
            }
        },

        debounceFetchOptions: debounce(function (search) {
            axios.get(route('api.movements.agencies.select') + '?search=' + search)
                .then(response => {
                    this.contacts = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        }, 500),

        fetchAgencies() {

            axios.get(route('api.movements.agencies.select'))
                .then(response => {

                    this.agencies = Object.values(response.data);

                    this.updateSelectedAgency();

                })
                .catch(error => {
                    console.error(error);
                });
        },

        updateSelectedAgency() {
            if (this.agencies && this.agencies.length > 0) {
                this.selectedAgency = this.agencies.find(agency => agency.id === this.agency.id) || null;
            } else {
                this.selectedAgency = null;
            }
        }

    },

    watch: {
        selectedContact: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.$emit('update:model-value', newVal);
                    this.$emit('update-contact', newVal);
                }
            }
        }
    }

}

</script>
